export default __webpack_public_path__ + "static/media/08_photo.c535e0d8.jpg";